//--------------------------------------------------------------------//
//----------------------- Parsers/Formatters -------------------------//
//--------------------------------------------------------------------//
import { grey } from "@mui/material/colors"
import { escapeRegExp } from "lodash"
import moment from "moment"
import dayjs from "dayjs"
import { isDate } from "date-fns"

export function getServerUrl() {
	if (process.env.REACT_APP_ENV === "DEV") {
		return "http://localhost:8080"
	}
	else if (process.env.REACT_APP_ENV === "PREPROD") {
		return "https://server-dot-kfc-preprod.appspot.com"
	}
	else if (process.env.REACT_APP_ENV === "PREVIEW") {
		return process.env.REACT_APP_SERVER_URL || "https://server-dot-kfc-preprod.appspot.com"
	}
	else if (process.env.REACT_APP_ENV === "PROD_KITCHEN") {
		return "https://kfc-api-kitchen.foodcheri.com"
	}
	else if (process.env.REACT_APP_ENV === "PROD_PRODUCT") {
		return "https://kfc-api-product.foodcheri.com"
	}
	else if (process.env.REACT_APP_ENV === "PROD_LOGISTIC") {
		return "https://kfc-api-logistic.foodcheri.com"
	}
}

export const isDev = process.env.REACT_APP_ENV === "DEV" || process.env.REACT_APP_ENV === "PREPROD" || process.env.REACT_APP_ENV === "PREVIEW"

export function getDataServerUrl() {
	if (process.env.REACT_APP_ENV === "DEV" ||
		process.env.REACT_APP_ENV === "PREPROD" ||
		process.env.REACT_APP_ENV === "PREVIEW"
	) {
		return "https://data-api-preprod-150816952184.europe-west1.run.app"
	}
	else if (process.env.REACT_APP_ENV === "PROD_KITCHEN" ||
		process.env.REACT_APP_ENV === "PROD_PRODUCT" ||
		process.env.REACT_APP_ENV === "PROD_LOGISTIC"
	) {
		return "https://data-api-prod-150816952184.europe-west1.run.app"
	}
}

export const getFCServerUrl = () => {
	if (process.env.REACT_APP_ENV === "DEV" || process.env.REACT_APP_ENV === "PREPROD" || process.env.REACT_APP_ENV === "PREVIEW") {
		return "https://server-foodcheri-dot-eatzy-server.appspot.com"
	}

	return "https://app.foodcheri.com"
}

//--------------------------------------------------------------------//
//----------------------------- Misc ---------------------------------//
//--------------------------------------------------------------------//
export function sort(array, keySupplier) {
	array.sort((item1, item2) => {
		const item1Key = keySupplier(item1)
		const item2Key = keySupplier(item2)
		if (item1Key < item2Key) return -1
		if (item1Key > item2Key) return 1
		return 0
	})
}

export function sortCommercialNames(a, b) {
	if (a.data.get("name") < b.data.get("name")) { return -1 }
	if (a.data.get("name") > b.data.get("name")) { return 1 }
	return 0
}

export function first(array) {
	return (array && array.length) ? array[0] : null
}
export function remove(array, itemOrFunction) {
	let i
	if (typeof itemOrFunction === "function") {
		i = array.findIndex(itemOrFunction)
	} else {
		i = array.indexOf(itemOrFunction)
	}
	if (i !== -1) {
		removeIndex(array, i)
		return true
	}
	return false
}
export function removeIndex(array, index) {
	array.splice(index, 1)
}

export function clone(instance) {
	return Object.assign(Object.create(instance), instance)
}

/**
 * @param object
 * @param {array|Set} names
 * @returns {*}
 */
export function filter(object, names) {
	return Object.keys(object)
		.filter(key => names.has ? names.has(key) : names.includes(key))
		.reduce((obj, key) => {
			obj[key] = object[key]
			return obj
		}, {})
}


//to capitalize only first letter
export function capitalizeFirstLetter(string) {
	if (string == null || !string.length) {
		return string
	}
	return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
}

export function intersectionSet(set1, set2) {
	return new Set([...set1].filter(x => set2.has(x)))
}


//--------------------------------------------//
//------------------- Forms ------------------//
//--------------------------------------------//
export function required({ values, fieldNames, errors = {} }) {
	fieldNames.forEach(fieldName => {
		if (!values[fieldName]) {
			errors[fieldName] = "Champ obligatoire"
		}
	})
	return errors
}

/**
 *
 * @param password
 * @param errors (optional)
 * @param name (default : 'password') the name of the field in errors
 * @returns {String | Object} if errors is passed, it returns it, otherwise it returns the eventual error message
 */
export function validatePassword(password, errors, name = "password") {
	//---- errorMessage ----//
	let errorMessage
	if (password == null || password.length < 8) {
		errorMessage = "Votre mot de passe doit faire au moins 8 caractères."
	}

	//---- errors ----//
	if (errors) {
		if (errorMessage) {
			errors[name] = errorMessage
		}
		return errors
	} else {
		return errorMessage
	}
}

export function roundNumber(number, decimal = 4) {
	if (isNaN(number)) {
		return ""
	}
	// Use toFixed+parseFloat to avoid float multiplication errors
	// e.g. Math.round(385.8 * 100) / 100 = 385.79 due to 385.8 * 100 = 38579.999...
	return parseFloat(Number(number).toFixed(decimal))
}

export function roundCurrency(number) {
	return roundNumber(number, 3)
}

export const isNumber = (value) => typeof value === "number"

/** by default parse limit the number of returned rows to 100
* we have to pass this parseLimitRequest to every .(limit) if we need to retrieve more
* parse method "defaultLimit" exists (it could be configured globally server-side) but is only available from v. 5.4.0 onwards
* @see https://github.com/parse-community/parse-server/pull/8152/files
**/

export const parseLimitRequest = 100000

export const fullSeason = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"]
export const recipeFields = [
	"name", "commercialName", "status", "type", "brands", "isActive", "internalTag", "season", "description",
	"tva", "dlc", "preparation", "specialInstruction", "heatingInstructions", "gesters", "portionPerPlate", "packaging",
	"subPackaging", "instructions", "sameInstructions", "difficulty", "sections", "sameDescriptions", "price", "ean",
	"news", "ingredientsComplexity", "reusablePackaging", "reusableSubPackaging", "defaultValues"
]

export const recipeDetailsFields = [
	"status", "type", "brands", "enterprises", "description", "dlc", "preparation", "heatingInstructions", "gesters", "packaging",
	"subPackaging", "reusablePackaging", "reusableSubPackaging", "instructions", "price", "portionPerPlate", "appImage",
	"kitchenImage", "difficulty", "specialInstruction", "defaultValues", "tva", "commercialNames",
	"packagingNumber", "packagingNumberUnit"
]

export const ingredientFields = [
	"name", "supplierArticleId", "supplierName", "storageArea", "genericId", "pricePerKg", "weightPerKg", "orderUnitWeight",
	"commercialName", "group", "allergens", "cookingModes"
]

export const packagingFields = [
	"name", "price", "type", "weight", "brands", "quantity", "reference", "categories", "height", "deepth", "width",
	"nature", "supplierItem", "enterprises"
]

export const subcontractorFields = [
	"name", "address", "contact", "minimumOrder", "sanitaryApprovalNumber", "countryCode", "continentCode", "canExportEtiquettable"
]

export const subcontractorProductFields = [
	"name", "commercialName", "status", "type", "brand", "subcontractor", "isActive", "internalTag",
	"subcontractorCommercialNames", "season", "description", "tva", "dlc", "preparation", "specialInstruction",
	"sections", "heatingInstructions", "packaging", "subPackaging", "reusablePackaging", "reusableSubPackagings", "totalCost", "price", "ean", "chef", "uniqueCode",
	"spicy"
]

export const allergenIngredientFields = [
	"name"
]

export const familyIngredientFields = [
	"name"
]

export const groupIngredientFields = [
	"name", "family"
]

export const subcontractorCommercialNameFields = [
	"name", "subcontractor", "group", "allergens", "conservationMode", "firstOrigin", "secondOrigin", "label",
	"firstOriginAverage", "secondOriginAverage", "season"
]

export const commercialNameFields = [
	"name", "group", "allergens", "conservationMode", "firstOrigin", "secondOrigin", "label", "firstOriginAverage",
	"secondOriginAverage", "season", "complexity"
]

export const productsTagsFields = [
	"name", "type"
]

export const PRODUCTION_SCHEMA_FIELDS = ["name", "batches"]

export const COLORS = {
	BACKGROUND_GREY: "#F8F8F8",
	BACKGROUND_LIGHT_GREY: "#F0F0F0",
	BLACK: "rgba(0, 0, 0, 0.87)",
	BLACK800: "#262626",
	BLACK_200: "#DBDBDB",
	BLACK_300: "#CCCCCC",
	BLACK_400: "#9B9B9B",
	BLACK_500: "#7C7C7C",
	BLACK_600: "#555555",
	BLACK_700: "#414141",
	BLACK_CARD: "rgba(0, 0, 0, 0.87)",
	BLUEGREY: "#607d8b",
	BLUE_100: "#BBDEFB",
	BLUEGREY_500: "#607d8b",
	BLUEGREY_700: "#455A64",
	BLUEGREY_900: "#263238",
	BLUEGREY_CUSTOM: "#E1EAEE",
	BLUE_CREDIT_DELETE: "#D4E7F7",
	BLUE_CREDIT_TOOLBAR: "#0075DA",
	BLUE_FOODCHERI: "#151858",
	BLUE_LOT_GROUP: "#3390dd",
	BLUE_PAPER_SELECTED: "#898989",
	DARK_BLUE_20: "#F5F7FF",
	DARK_BLUE_50: "#E3E9F9",
	DARK_BLUE_100: "#CED8F5",
	DARK_BLUE_200: "#607FE0",
	BLUE_600: "#1E86E5",
	BROWN: "#FF6F00",
	ORANGE_300: "#EFAA3E",
	GREEN_500: "#3EA15B",
	ORANGE_AMBER_900: "#FF6F00",
	BUTTON_INHERITED: "#603598",
	DARK_BLACK: "#000000",
	DARK_GREY: "#757575",
	DARK_YELLOW_100: "#F6D74F",
	DEFAULT_GREY: "#D8D8D8",
	DELIVERY_NOTE_CARD_SHADOW1: "rgba(0, 0, 0, 0.12)",
	DELIVERY_NOTE_CARD_SHADOW2: "rgba(0, 0, 0, 0.24)",
	DELIVERY_NOTE_CARD_TITLE: "#A3A3A3",
	DISABLED: "#a0a0a0",
	DISABLED_DRAG: "#FFBDBD",
	DISABLED_INPUT_COLOR: "#F9F9F9",
	DOWNLOAD_DOCUMENT_BLUE: "#2196F3",
	DRAFT_GREY: "#7C7C7C",
	ENABLED_DRAG: "#DCFFEA",
	GREEN_50: "#EBF7EE",
	GREEN_100: "#c8e6c9",
	GREEN_200: "#a5d6a7",
	GREEN_300: "#ADE1BB",
	GREEN_400: "#66bb6a",
	GREEN_CARD_INVENTORY: "#E8F5E9",
	GREEN_CARD_TEXT: "#689F38",
	GREEN_INVENTORY: "#00C853",
	GREEN_LOT_INVENTORY: "#F1FFF2",
	GREEN_800: "#368F50",
	GREEN_NUTRITION: "#43A741",
	GREEN_PLANNING: "#E6F4E6",
	GREEN_SEAZON: "#25B598",
	GREEN_STATUS: "#007E65",
	GREEN_VALIDATOR: "#0BA812",
	GREEN_SUCCESS_50: "#EBF7EE",
	GREEN_SUCCESS_300: "#89D69F",
	GREEN_SUCCESS_800: "#368F50",
	GREY_700: "#616161",
	GREY_900: "#1A1A1A",
	GREY_BACK_BUTTON: "#9E9E9E",
	GREY_BORDER: "#BDBDBD",
	GREY_CARD_BLURED: "#E3E3E3",
	GREY_DISABLED: "#4C4C4C",
	GREY_FLAW_ICON: "#C4C4C4",
	GREY_IMAGE_LIST: "#F6F6F6",
	GREY_NAT_BORDER: grey[300],
	GREY_ORDER_BORDER: "#DCDCDC",
	GREY_RECIPE_BACKGROUND: "#e5e5e5",
	GREY_SEARCH: "rgba(0, 0, 0, 0.54)",
	GREY_SUPPLIER_BACKGROUND: "#FCFCFC",
	PRIMARY_BLUE_20: "#F0F9FF",
	HEAD_FC: "#151858",
	HEAD_FRIGO: "#D2B800",
	HEAD_MONOP: "#f52b27",
	HEAD_SEAZON: "#25B598",
	INFORMATION_TITLE: "rgba(0, 0, 0, 0.6)",
	INGREDIENT_INHERITED: "#F8F3FF",
	INVENTORY_BOX_SHADOW: "rgba(0, 0, 0, 0.2)",
	LABEL_GREY: "#555555",
	LEFT_FILTER_SEARCH: "#d9eef4",
	LIGHT_BLACK: "#212121",
	LIGHT_BLUE_SLIDER: "#3880ff",
	GREEN_SUCCESS_100: "#CEECD6",
	LIGHT_GREY: "#F7F7F7",
	LIGHT_GREY_2: "#FAFAFA",
	LIGHT_GREY_3: "#EEEEEE",
	LIGHT_PRIMARY_COLOR: "#68B6F4",
	LIGHT_SLIDER: "#bfbfbf",
	MEDIUM_GREY: "#E7E7E7",
	MINT_50: "#E6F9F4",
	MINT_200: "#94E4D2",
	MINT_300: "#66D8BE",
	MINT_500: "#2CC9AA",
	ORANGE_CREDIT_NOTE: "#FB7311",
	ORANGE_INVENTORY_BACKGROUND: "rgba(255, 115, 15, 0.5)",
	ORANGE_INVENTORY_BORDER: "rgba(255, 115, 15, 1)",
	ORANGE_PLANNING: "#FFF1DB",
	ORANGE_50: "#FFF8E1",
	ORANGE_100: "#FDF0D2",
	ORANGE_150: "#F7D274",
	ORANGE_200: "#F2C046",
	ORANGE_800: "#B45309",
	ORDER_BLUE: "rgba(33, 150, 243, 0.5)",
	PACKAGING_CAPPED: "#FEE39E",
	PACKAGING_DISPOSABLE: "#D0B298",
	PACKAGING_EXECUTION_YELLOW: "#F2C046",
	PACKAGING_REUSABLE: "#CEECD6",
	PACKAGING_ROW_SELECTED: "rgba(0, 0, 0, 0.04)",
	PRIMARY_COLOR: "#2196F3",
	PRODUCTION_RECEPTION_COLOR: "#2196F3",
	PRIMARY_BLUE_500: "#41A3F5",
	PRIMARY_BLUE_50: "#E3F2FD",
	PRIMARY_BLUE_200: "#90C9F9",
	PRIMARY_BORDER: "#E6E6E6",
	BLUE_50: "#E3F2FD",
	PRODUCTION_STEPS_COMPONENT_WHITE: "#FFF",
	PRODUCTION_STEPS_DISABLE_TEXT: "#9B9B9B",
	BLACK_50: "#F8F8F8",
	PRODUCTION_STEPS_TEXT_GREY: "#414141",
	PURPLE_50: "#F1E7FF",
	PURPLE_100: "#D8BBFF",
	PURPLE_800: "#5B21B6",
	RED: "#FF5D5A",
	RED_100: "#ffcdd2",
	RED_200: "#ef9a9a",
	RED_50: "#ffebee",
	RED_600: "#EB173E",
	RED_700: "#D90236",
	RED_800: "#CC0030",
	RED_900: "#BE0024",
	RED_BROKEN: "#F53635",
	RED_ERROR: "#f44336",
	RED_ERROR_LIGHT: "#F44259",
	RED_FLAW: "#FF1744",
	RED_INVENTORY_BACKGROUND: "rgba(255, 0, 0, 0.5)",
	RED_INVENTORY_WARNING: "#E53935",
	YELLOW_INVENTORY_BACKGROUND: "rgba(255, 190, 21, 0.4)",
	YELLOW_INVENTORY_BORDER: "rgba(255, 190, 21, 1)",
	RED_NUTRITION: "#E10050",
	RED_PLANNING: "#FFDCDC",
	RED_RASPBERRY: "#E50050",
	RED_SECONDARY: "#D50000",
	RED_WARNING: "#F53531",
	RIGHT_DESCRIPTION_BKG: "#F5F5F5",
	RIGHT_TAG_CHIP: "#F6F7F7",
	SECONDARY_COLOR: "#e91e63",
	SECONDARY_DLC_BLUE: "#1045A1",
	SECTION_INHERITED: "#D7C6ED",
	SELECTED_GREY: "#d0d0d0",
	SITE_BORDER: "#DADADA",
	SITE_BOX_SHADOW: "rgba(0, 0, 0, 0.05)",
	SITE_INFORMATION_VALUE: "#555555",
	SITE_SUBTITLE: "#C0C0C0",
	STEP_INHERITED: "#E7DCF7",
	SUPPLIER_DELIVERY_COlOR: "#4CAF50",
	TEXT_COLOR_FOR_PRIMARY: "#ffffff",
	THEORICAL_TIME_PSE: "#9B9B9B",
	UTILITARY_PURPLE: "#7900D9",
	VIOLET_DISPATCH: "#f200ff",
	WHITE: "#ffffff",
	WHITE_INPUT: "rgba(255, 255, 255, 0.83)",
	YELLOW_OUTPUT: "#FFBE15",
	YELLOW_100: "#FDF9C9",
	OUTPUT_KITCHEN_50: "#FFF3D6",
	OUTPUT_KITCHEN_300: "#E8B940",
	OUTPUT_KITCHEN_900: "#6B4A00",
	PURPLE_300: "#B48CF2",
	BLUE_700: "#1976D2"
}

export const KFC_BRANDS = [
	{
		name: "FOODCHERI",
		shortname: "FC",
		label: "FoodChéri",
		isActive: true,
		color: "#000000",
		image: "/img/FC_Black@2x.png",
		whiteImage: "/img/FC_white@2x.png",
		nationalSendField: true, // true if we can disable national send in meal planner
		sendCapitalField: true,
		smallRetailField: false,
		lunchbagField: true, // true if we can set an item to lunchbag in meal planner
		priceEnabled: true, // If false we cannot change the price in recipe form
		sellPageTags: [ // Count by tags to display in sell planning section headers
			{ key: "Vegan", displayName: "Vegans", sections: [] }, // If sections is empty, it displays it everywhere
			{ key: "Végétarien", displayName: "Végétariens", sections: [] },
			{ key: "Froid", displayName: "Froids", sections: [] },
			{ key: "FC Corner", displayName: "FC corner", sections: [] },
			{ key: "Petit prix", displayName: "Petit prix", sections: ["MAIN_COURSE"] }
		],
		defaultHeatingInstructions: {
			microwave: {
				power: 900,
				duration: 2.5,
				instructions: "Retirez le couvercle avant de réchauffer"
			},
			oven: {
				power: 150,
				duration: 12,
				instructions: "Transférez dans un plat adapté"
			},
			pan: {
				power: "",
				duration: "",
				instructions: ""
			}
		},
		recipesList: {
			displayFoodcostPCT: true
		},
		monitoring: {
			types: ["STARTER", "MAIN_COURSE+MEAL_PREP", "DESSERT", "BREAD", "CHEESE"] // Types of item to display in monitoring view
		},
		applyWaste: true,
		pctLimit: 22
	},
	{
		name: "SEAZON",
		shortname: "SZ",
		label: "Seazon",
		isActive: true,
		color: "#25B598",
		image: "/img/logoszn.png",
		whiteImage: "/img/whitelogoszn.png",
		nationalSendField: false,
		sendCapitalField: true,
		smallRetailField: false,
		lunchbagField: false,
		priceEnabled: true,
		sellPageTags: [
			{ key: "Vegan", displayName: "Vegans", sections: [] },
			{ key: "Végétarien", displayName: "Végétariens", sections: [] },
			{ key: "Froid", displayName: "Froids", sections: [] },
			{ key: "SZ Athletics", displayName: "SZN Athletics", sections: [] }
		],
		defaultHeatingInstructions: {
			microwave: {
				power: 900,
				duration: 2.5,
				instructions: "Soulevez l'opercule et réchauffez"
			},
			oven: {
				power: 150,
				duration: 12,
				instructions: "Transférez dans un plat adapté"
			},
			pan: {
				power: "",
				duration: "",
				instructions: ""
			}
		},
		recipesList: {
			displayFoodcostPCT: false
		},
		monitoring: {
			types: ["BREAKFAST", "MAIN_COURSE+MEAL_PREP"]
		},
		applyWaste: false,
		pctLimit: 26.5
	},
	{
		name: "MONOPRIX",
		shortname: "MN",
		label: "Monop'",
		isActive: false,
		color: "#f52b27",
		image: "/img/logomonop.png",
		whiteImage: "/img/whitelogomonop.png",
		nationalSendField: true,
		sendCapitalField: true,
		smallRetailField: true,
		lunchbagField: false,
		priceEnabled: true,
		sellPageTags: [
			// TODO: fill this array
		],
		defaultHeatingInstructions: {
			microwave: {
				power: 900,
				duration: 2.5,
				instructions: "Soulevez l'opercule et réchauffez"
			},
			oven: {
				power: 150,
				duration: 12,
				instructions: "Transférez dans un plat adapté"
			},
			pan: {
				power: "",
				duration: "",
				instructions: ""
			}
		},
		recipesList: {
			displayFoodcostPCT: false
		},
		monitoring: {
			types: ["MAIN_COURSE+MEAL_PREP"]
		},
		applyWaste: false,
		pctLimit: 31
	},
	{
		name: "FRIGONU",
		shortname: "NU",
		label: "FrigoCo",
		isActive: true,
		color: "#D2B800",
		image: "/img/logofrigoco.png",
		whiteImage: "/img/whitelogofrigoco.png",
		nationalSendField: true,
		sendCapitalField: true,
		smallRetailField: true,
		lunchbagField: false,
		priceEnabled: true,
		sellPageTags: [
			// TODO: fill this array
		],
		defaultHeatingInstructions: {
			microwave: {
				power: 900,
				duration: 2.5,
				instructions: "Soulevez l'opercule et réchauffez"
			},
			oven: {
				power: 150,
				duration: 12,
				instructions: "Transférez dans un plat adapté"
			},
			pan: {
				power: "",
				duration: "",
				instructions: ""
			}
		},
		recipesList: {
			displayFoodcostPCT: false
		},
		monitoring: {
			types: ["MAIN_COURSE+MEAL_PREP", "DESSERT+YAOURT"] // Types of item to display in monitoring view
		},
		applyWaste: false,
		pctLimit: 31
	},
	{
		name: "SEAZON_BE",
		shortname: "SZ_BE",
		label: "Seazon BE",
		isActive: false,
		color: "#9C2762",
		image: "/img/logosznbe.png",
		whiteImage: "/img/whitelogosznbe.png",
		nationalSendField: false,
		sendCapitalField: true,
		smallRetailField: false,
		lunchbagField: false,
		priceEnabled: true,
		sellPageTags: [
			{ key: "Vegan", displayName: "Vegans", sections: [] },
			{ key: "Végétarien", displayName: "Végétariens", sections: [] },
			{ key: "Froid", displayName: "Froids", sections: [] },
			{ key: "SZ Athletics", displayName: "SZN Athletics", sections: [] }
		],
		defaultHeatingInstructions: {
			microwave: {
				power: 900,
				duration: 2.5,
				instructions: "Soulevez l'opercule et réchauffez"
			},
			oven: {
				power: 150,
				duration: 12,
				instructions: "Transférez dans un plat adapté"
			},
			pan: {
				power: "",
				duration: "",
				instructions: ""
			}
		},
		recipesList: {
			displayFoodcostPCT: false
		},
		monitoring: {
			types: ["MAIN_COURSE+MEAL_PREP", "BREAKFAST"]
		},
		applyWaste: false,
		pctLimit: 26.5
	},
	{
		name: "EMPLOYEES_MEALS",
		shortname: "PERSO",
		label: "Repas Perso",
		isActive: true,
		color: "#FFAF37",
		image: "/img/logorepasperso.png",
		whiteImage: "/img/whitelogorepasperso.png",
		nationalSendField: true,
		sendCapitalField: true,
		smallRetailField: false,
		lunchbagField: false,
		priceEnabled: false,
		sellPageTags: [
			// TODO: fill this array
		],
		defaultHeatingInstructions: {
			microwave: {
				power: 900,
				duration: 2.5,
				instructions: "Soulevez l'opercule et réchauffez"
			},
			oven: {
				power: 150,
				duration: 12,
				instructions: "Transférez dans un plat adapté"
			},
			pan: {
				power: "",
				duration: "",
				instructions: ""
			}
		},
		recipesList: {
			displayFoodcostPCT: false
		},
		monitoring: {
			types: ["MAIN_COURSE"] // Types of item to display in monitoring view
		},
		applyWaste: false,
		pctLimit: 31
	},
	{
		name: "OLYMPIC_GAMES",
		shortname: "JO",
		label: "Les Commis",
		isActive: true,
		color: "#FF69DD",
		image: "/img/brands/og_logo.svg",
		whiteImage: "/img/brands/og_logo.svg",
		nationalSendField: true,
		sendCapitalField: true,
		smallRetailField: false,
		lunchbagField: false,
		priceEnabled: false,
		sellPageTags: [
			// TODO: fill this array
		],
		defaultHeatingInstructions: {
			microwave: {
				power: 900,
				duration: 2.5,
				instructions: "Retirez le couvercle avant de réchauffer"
			},
			oven: {
				power: 150,
				duration: 12,
				instructions: "Transférez dans un plat adapté"
			},
			pan: {
				power: "",
				duration: "",
				instructions: ""
			}
		},
		recipesList: {
			displayFoodcostPCT: true
		},
		monitoring: {
			types: ["MAIN_COURSE"] // Types of item to display in monitoring view
		},
		applyWaste: false,
		pctLimit: 31
	},
	{
		name: "SOGERES",
		shortname: "SO",
		label: "Étoile Saint Honoré",
		isActive: true,
		color: "#958ade",
		image: "/img/brands/so_logo.svg",
		whiteImage: "/img/brands/so_logo.svg",
		nationalSendField: true,
		sendCapitalField: true,
		smallRetailField: false,
		lunchbagField: false,
		priceEnabled: false,
		sellPageTags: [
			// TODO: fill this array
		],
		defaultHeatingInstructions: {
			microwave: {
				power: 900,
				duration: 2.5,
				instructions: "Retirez le couvercle avant de réchauffer"
			},
			oven: {
				power: 150,
				duration: 12,
				instructions: "Transférez dans un plat adapté"
			},
			pan: {
				power: "",
				duration: "",
				instructions: ""
			}
		},
		recipesList: {
			displayFoodcostPCT: true
		},
		monitoring: {
			types: ["MAIN_COURSE"] // Types of item to display in monitoring view
		},
		applyWaste: false,
		pctLimit: 31
	},
	{
		name: "MORNING",
		shortname: "MO",
		label: "INSEAD Viatte",
		isActive: true,
		color: "#05aaf7ff",
		image: "/img/brands/mo_logo.svg",
		whiteImage: "/img/brands/mo_logo.svg",
		nationalSendField: true,
		sendCapitalField: true,
		smallRetailField: false,
		lunchbagField: false,
		priceEnabled: false,
		sellPageTags: [
			// TODO: fill this array
		],
		defaultHeatingInstructions: {
			microwave: {
				power: 900,
				duration: 2.5,
				instructions: "Retirez le couvercle avant de réchauffer"
			},
			oven: {
				power: 150,
				duration: 12,
				instructions: "Transférez dans un plat adapté"
			},
			pan: {
				power: "",
				duration: "",
				instructions: ""
			}
		},
		recipesList: {
			displayFoodcostPCT: true
		},
		monitoring: {
			types: ["MAIN_COURSE"] // Types of item to display in monitoring view
		},
		applyWaste: false,
		pctLimit: 31
	}
	,
	{
		name: "INSEAD_CLOS",
		shortname: "ISD_C",
		label: "INSEAD Clos",
		isActive: true,
		color: "#006fa2ff",
		image: "/img/brands/isd_c_logo.svg",
		whiteImage: "/img/brands/isd_c_logo.svg",
		nationalSendField: true,
		sendCapitalField: true,
		smallRetailField: false,
		lunchbagField: false,
		priceEnabled: false,
		sellPageTags: [
			// TODO: fill this array
		],
		defaultHeatingInstructions: {
			microwave: {
				power: 900,
				duration: 2.5,
				instructions: "Retirez le couvercle avant de réchauffer"
			},
			oven: {
				power: 150,
				duration: 12,
				instructions: "Transférez dans un plat adapté"
			},
			pan: {
				power: "",
				duration: "",
				instructions: ""
			}
		},
		recipesList: {
			displayFoodcostPCT: true
		},
		monitoring: {
			types: ["MAIN_COURSE"] // Types of item to display in monitoring view
		},
		applyWaste: false,
		pctLimit: 31
	},
	{
		name: "EXTERNAL",
		shortname: "EXT",
		label: "Prestation Externe 1",
		isActive: true,
		color: "#85040a",
		image: "/img/brands/ext_logo.svg",
		whiteImage: "/img/brands/ext_logo.svg",
		nationalSendField: true,
		sendCapitalField: true,
		smallRetailField: false,
		lunchbagField: false,
		priceEnabled: false,
		sellPageTags: [
			// TODO: fill this array
		],
		defaultHeatingInstructions: {
			microwave: {
				power: 900,
				duration: 2.5,
				instructions: "Retirez le couvercle avant de réchauffer"
			},
			oven: {
				power: 150,
				duration: 12,
				instructions: "Transférez dans un plat adapté"
			},
			pan: {
				power: "",
				duration: "",
				instructions: ""
			}
		},
		recipesList: {
			displayFoodcostPCT: true
		},
		monitoring: {
			types: ["MAIN_COURSE"] // Types of item to display in monitoring view
		},
		applyWaste: false,
		pctLimit: 31
	},
	{
		name: "EXTERNAL_2",
		shortname: "EXT2",
		label: "Prestation Externe 2",
		isActive: true,
		color: "#531607",
		image: "/img/brands/ext2_logo.svg",
		whiteImage: "/img/brands/ext2_logo.svg",
		nationalSendField: true,
		sendCapitalField: true,
		smallRetailField: false,
		lunchbagField: false,
		priceEnabled: false,
		sellPageTags: [],
		defaultHeatingInstructions: {
			microwave: {
				power: 900,
				duration: 2.5,
				instructions: "Retirez le couvercle avant de réchauffer"
			},
			oven: {
				power: 150,
				duration: 12,
				instructions: "Transférez dans un plat adapté"
			},
			pan: {
				power: "",
				duration: "",
				instructions: ""
			}
		},
		recipesList: {
			displayFoodcostPCT: true
		},
		monitoring: {
			types: ["MAIN_COURSE"] // Types of item to display in monitoring view
		},
		applyWaste: false,
		pctLimit: 31
	},
	{
		name: "SODEXO_LIVE",
		shortname: "SL",
		label: "Sodexo Live",
		isActive: true,
		color: "#48752C",
		image: "/img/brands/sodexo_live_logo.svg",
		whiteImage: "/img/brands/sodexo_live_logo.svg",
		nationalSendField: true,
		sendCapitalField: true,
		smallRetailField: false,
		lunchbagField: false,
		priceEnabled: false,
		sellPageTags: [],
		defaultHeatingInstructions: {
			microwave: {
				power: 900,
				duration: 2.5,
				instructions: "Retirez le couvercle avant de réchauffer"
			},
			oven: {
				power: 150,
				duration: 12,
				instructions: "Transférez dans un plat adapté"
			},
			pan: {
				power: "",
				duration: "",
				instructions: ""
			}
		},
		recipesList: {
			displayFoodcostPCT: true
		},
		monitoring: {
			types: ["MAIN_COURSE"] // Types of item to display in monitoring view
		},
		applyWaste: false,
		pctLimit: 31
	},
	{
		name: "PONANT",
		shortname: "PO",
		label: "Le Ponant",
		isActive: true,
		color: "#62F8C4",
		image: "/img/brands/LePonant.svg",
		whiteImage: "/img/brands/LePonant.svg",
		nationalSendField: true,
		sendCapitalField: true,
		smallRetailField: false,
		lunchbagField: false,
		priceEnabled: false,
		sellPageTags: [],
		defaultHeatingInstructions: {
			microwave: {
				power: 900,
				duration: 2.5,
				instructions: "Retirez le couvercle avant de réchauffer"
			},
			oven: {
				power: 150,
				duration: 12,
				instructions: "Transférez dans un plat adapté"
			},
			pan: {
				power: "",
				duration: "",
				instructions: ""
			}
		},
		recipesList: {
			displayFoodcostPCT: true
		},
		monitoring: {
			types: ["MAIN_COURSE"] // Types of item to display in monitoring view
		},
		applyWaste: false,
		pctLimit: 31
	},
	{
		name: "QUITOQUE",
		shortname: "QT",
		label: "Quitoque-M1V1",
		isActive: true,
		color: "#FF6B35",
		image: "/img/brands/quitoque_logo.svg",
		whiteImage: "/img/brands/quitoque_logo.svg",
		nationalSendField: true,
		sendCapitalField: true,
		smallRetailField: false,
		lunchbagField: false,
		priceEnabled: false,
		sellPageTags: [],
		defaultHeatingInstructions: {
			microwave: {
				power: 900,
				duration: 2.5,
				instructions: "Retirez le couvercle avant de réchauffer"
			},
			oven: {
				power: 150,
				duration: 12,
				instructions: "Transférez dans un plat adapté"
			},
			pan: {
				power: "",
				duration: "",
				instructions: ""
			}
		},
		recipesList: {
			displayFoodcostPCT: true
		},
		monitoring: {
			types: ["MAIN_COURSE"] // Types of item to display in monitoring view
		},
		applyWaste: false,
		pctLimit: 31
	},
	{
		name: "QUITOQUE-M2",
		shortname: "QM2",
		label: "Quitoque-M2",
		isActive: true,
		color: "#CC4A1A",
		image: "/img/brands/quitoque_m2_logo.svg",
		whiteImage: "/img/brands/quitoque_m2_logo.svg",
		nationalSendField: true,
		sendCapitalField: true,
		smallRetailField: false,
		lunchbagField: false,
		priceEnabled: false,
		sellPageTags: [],
		defaultHeatingInstructions: {
			microwave: {
				power: 900,
				duration: 2.5,
				instructions: "Retirez le couvercle avant de réchauffer"
			},
			oven: {
				power: 150,
				duration: 12,
				instructions: "Transférez dans un plat adapté"
			},
			pan: {
				power: "",
				duration: "",
				instructions: ""
			}
		},
		recipesList: {
			displayFoodcostPCT: true
		},
		monitoring: {
			types: ["MAIN_COURSE"]
		},
		applyWaste: false,
		pctLimit: 31
	},
	{
		name: "MUSEE",
		shortname: "MU",
		label: "Musée",
		isActive: true,
		color: "#3D5A80",
		image: "/img/brands/musee_logo.svg",
		whiteImage: "/img/brands/musee_logo.svg",
		nationalSendField: true,
		sendCapitalField: true,
		smallRetailField: false,
		lunchbagField: false,
		priceEnabled: false,
		sellPageTags: [],
		defaultHeatingInstructions: {
			microwave: {
				power: 900,
				duration: 2.5,
				instructions: "Retirez le couvercle avant de réchauffer"
			},
			oven: {
				power: 150,
				duration: 12,
				instructions: "Transférez dans un plat adapté"
			},
			pan: {
				power: "",
				duration: "",
				instructions: ""
			}
		},
		recipesList: {
			displayFoodcostPCT: true
		},
		monitoring: {
			types: ["MAIN_COURSE"]
		},
		applyWaste: false,
		pctLimit: 31
	},
	{
		name: "FRENCH_TOUR_DEPART",
		shortname: "TDFD",
		label: "Tour de France - départ",
		isActive: true,
		color: "#FF1414",
		image: "/img/brands/tdf_depart_logo.svg",
		whiteImage: "/img/brands/tdf_depart_logo.svg",
		nationalSendField: true,
		sendCapitalField: true,
		smallRetailField: false,
		lunchbagField: false,
		priceEnabled: false,
		sellPageTags: [],
		defaultHeatingInstructions: {
			microwave: {
				power: 900,
				duration: 2.5,
				instructions: "Retirez le couvercle avant de réchauffer"
			},
			oven: {
				power: 150,
				duration: 12,
				instructions: "Transférez dans un plat adapté"
			},
			pan: {
				power: "",
				duration: "",
				instructions: ""
			}
		},
		recipesList: {
			displayFoodcostPCT: true
		},
		monitoring: {
			types: ["MAIN_COURSE"]
		},
		applyWaste: false,
		pctLimit: 31
	},
	{
		name: "FRENCH_TOUR_ARRIVEE",
		shortname: "TDFA",
		label: "Tour de France - arrivée",
		isActive: true,
		color: "#8B0000",
		image: "/img/brands/tdf_arrivee_logo.svg",
		whiteImage: "/img/brands/tdf_arrivee_logo.svg",
		nationalSendField: true,
		sendCapitalField: true,
		smallRetailField: false,
		lunchbagField: false,
		priceEnabled: false,
		sellPageTags: [],
		defaultHeatingInstructions: {
			microwave: {
				power: 900,
				duration: 2.5,
				instructions: "Retirez le couvercle avant de réchauffer"
			},
			oven: {
				power: 150,
				duration: 12,
				instructions: "Transférez dans un plat adapté"
			},
			pan: {
				power: "",
				duration: "",
				instructions: ""
			}
		},
		recipesList: {
			displayFoodcostPCT: true
		},
		monitoring: {
			types: ["MAIN_COURSE"]
		},
		applyWaste: false,
		pctLimit: 31
	}
]

export const ACTIVE_KFC_BRANDS = KFC_BRANDS.filter(brand => brand.isActive)

export const ACTIVE_KFC_BRANDS_NAMES = ACTIVE_KFC_BRANDS.map(brand => brand.name)

export function forEachBrand(callback, activeOnly = false) { // shortcut, avoid to write loops everywhere
	const BRANDS = activeOnly ? ACTIVE_KFC_BRANDS : KFC_BRANDS
	for (const brand of BRANDS) {
		callback(brand)
	}
}

export const FORCE_DISPLAY_SIDEBAR_URLS = [
	"/productionStepExecutions/filter",
	"/productionStepExecutions/prodPlanner/filter",
	"/productionStepExecutions/prodPlanner/view",
	"/productionReception/filter",
]

export const HIDE_SIDEBAR_STANDARD_URLS = [
	"/settings/administration/productTypes/edition",
	"/settings/production/productionSchemas/form",
	"/productionStepExecutions/consultation",
	"/productionStepExecutions/hours",
	"lotInventory/lotEventsHistory"
]

export const HIDE_SIDEBAR_DYNAMIC_URLS = [
	/** BRIQUE PLANIFICATION **/
	{ path: "/mealplanner/", minLength: 25 },
	{ path: "/weeklyMealplanner/", minLength: 25 },

	/** BRIQUE APPRO  **/
	{ path: "/order/", minLength: 19 }, // ex: order/UPK3lbT78C/BfsuV39E8o
	{ path: "/order/", minLength: 7 }, // ex: order/UPK3lbT78C
	{ path: "/orders/", minLength: 9 }, // ex: orders/UPK3lbT78C
	{ path: "/orderReceptions/", minLength: 43 }, // ex: /orderReceptions/UPK3lbT78C/1706832000000/P65NdYrLmY
	{ path: "/billingCreditNotes/", minLength: 57 }, // ex: /billingCreditNotes/UPK3lbT78C/1706832000000/P65NdYrLmY/control
	{ path: "/orderReceptions/", minLength: 54 }, // ex: /orderReceptions/UPK3lbT78C/1709856000000/FGsLhpGrAI/deliveryNoteControl

	/** BRIQUE APPRO**/
	{ path: "/lotInventory/lotEventsHistory/", minLength: 30 },

	/** BRIQUE PRODUCTION **/
	{ path: "/packagingExecutions/read/", minLength: 27 }, // ex: /packagingExecutions/read/UPK3lbT78C/2024-03-19
	{ path: "/packagingExecutions/hours/", minLength: 27 }, // ex: /packagingExecutions/hours/UPK3lbT78C/2024-03-19
	{ path: "/packagingExecutions/packagingExecution/", minLength: 63 }, // ex: /packagingExecutions/packagingExecution/UPK3lbT78C/2024-03-18/gCh0IUsm47
	{ path: "/productionStepExecutions/hours/", minLength: 33 },
	{ path: "/productionStepExecutions/preparation/", minLength: 39 },
	{ path: "/productionStepExecutions/", minLength: 27 }, // productionStepExecutions/yvtFPBJgdd

	/** BRIQUE SETTINGS  **/
	{ path: "/settings/resources/section/", minLength: 29 },
	{ path: "/settings/resources/reusableSteps/edit/", minLength: 40 },

	/** PRODUCTION RECEPTION **/
	{ path: "/productionReception/", minLength: 21 },
]
/**
 * get brand label from list of brand value (from db)
 * @param {*} brands 
 * @returns 
 */
export const getBrandsLabels = (brands = []) => {
	const filteredBrands = ACTIVE_KFC_BRANDS.filter(brand => brands.includes(brand.name))
	const labels = filteredBrands.map(brand => brand.label) || []
	return labels.join(", ")
}

export function getBrandMonitoringName(brand, type) {
	return KFC_BRANDS.find(b => b.name === brand).monitoring.types.find(typ => typ.split("+").includes(type))
}

/**
 * get database product brands data (ex: image, label)
 * @param {*} brands 
 * @returns 
 */
export const getBrandsData = (brands) => KFC_BRANDS.filter((brand) => brands.includes(brand.name))

export function getMenuProps() {
	const ITEM_HEIGHT = 48
	const ITEM_PADDING_TOP = 8

	return {
		PaperProps: {
			style: {
				maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
				width: 250,
			},
		},
	}
}

export function getBrandBy(criteria, value) {
	return KFC_BRANDS.find(brand => brand[criteria] === value)
}

export const getBrandsOptions = (brands = ACTIVE_KFC_BRANDS) => {
	return brands.map(brand => ({ value: brand.name, label: brand.label }))
}

export const DEFAULT_DASHBOARD_VIEW = "MONITORING"

// check connecte device tablet or
export function checkTablet() {
	const width = window.innerWidth
	const height = window.innerHeight

	// display screen for tablet or mobile
	if (width < 1024 && height <= 1280) {
		return true
	}

	return false
}

export function setSearchValue(value, scope) {
	let storage = JSON.parse(localStorage.getItem("searchValue"))
	if (!storage) storage = {}

	storage[scope] = value
	localStorage.setItem("searchValue", JSON.stringify(storage))
}

export function setRecipeListStorage(value, scope) {
	let storage = JSON.parse(localStorage.getItem("recipeList"))
	if (!storage) storage = {
		brands: null,
		types: null,
		Status: null,
		isActive: null
	}

	storage[scope] = value
	localStorage.setItem("recipeList", JSON.stringify(storage))
}

export function resetRecipeListStorage() {
	let storage = JSON.parse(localStorage.getItem("recipeList"))
	if (storage) storage = {
		brands: null,
		types: null,
		Status: null,
		isActive: null
	}

	localStorage.setItem("recipeList", JSON.stringify(storage))
}

export function setSubcontractorProductListStorage(value, scope) {
	let storage = JSON.parse(localStorage.getItem("subcontractorProductList"))
	if (!storage) storage = {
		brands: null,
		types: null,
		Status: null,
		isActive: null,
		subcontractors: null
	}

	storage[scope] = value
	localStorage.setItem("subcontractorProductList", JSON.stringify(storage))
}

export function resetSubcontractorProductListStorage() {
	let storage = JSON.parse(localStorage.getItem("recipeList"))
	if (storage) storage = {
		brands: null,
		types: null,
		Status: null,
		isActive: null,
		subcontractors: null
	}

	localStorage.setItem("subcontractorProductList", JSON.stringify(storage))
}

export function setLotInventoryOutputStorage(value, scope, mode) {
	let storage = JSON.parse(localStorage.getItem("filterLotInventoryOutput"))

	if (!storage || (storage && !storage[mode])) {
		if (!storage) storage = {}

		storage[mode] = {
			dlc: null,
			groupIngredients: null
		}
	}

	storage[mode][scope] = value
	localStorage.setItem("filterLotInventoryOutput", JSON.stringify(storage))
}

export function resetLotInventoryOutputStorage(mode) {
	let storage = JSON.parse(localStorage.getItem("filterLotInventoryOutput"))
	if (storage && storage[mode]) storage = {
		dlc: null,
		groupIngredients: null
	}

	localStorage.setItem("filterLotInventoryOutput", JSON.stringify(storage))
}

export const filterWithSearchValue = (searchValue, toFiltered, filterOn = "name", ingredient = false) => {
	let newFilter = []
	if (searchValue !== null && searchValue !== "") {
		const regex = new RegExp(escapeRegExp(searchValue), "ig")
		if (!ingredient) {
			newFilter = toFiltered.filter(elm => elm[filterOn] && elm[filterOn].toString().match(regex) !== null)
		} else {
			newFilter = toFiltered.filter(elem => (elem.commercialName && elem.commercialName.name.match(regex)))
		}
	} else {
		newFilter = toFiltered
	}

	return newFilter
}

export const filterOnSomeFields = (searchValue, toFiltered, filterOn) => {
	let newFilter = []
	if (searchValue !== null && searchValue !== "") {
		const regex = new RegExp(searchValue, "ig")
		newFilter = toFiltered.filter(elm => filterOn.some(f => elm[f] && elm[f].match(regex) !== null))
	} else {
		newFilter = toFiltered
	}

	return newFilter
}

/**
 * check if a filters is saved to the store
 * @param {*} filters name, productTypes, suppliers
 * @returns 
 */
export const hasSupplierItemsSavedFilter = (filters) => {
	return Object.keys(filters).some(key => {
		// name field
		if (typeof filters[key] === "string") {
			return filters[key]
		}
		// productTypes & suppliers field
		return filters[key].length > 0
	})
}

export const checkMultiSelectInclude = (source, selected, value) => {
	let newSelected = value

	if (!selected.includes("ALL") && value.includes("ALL")) {
		newSelected = source.map(elem => elem.value)
	}
	else if (selected.includes("ALL") && !value.includes("ALL")) {
		newSelected = []
	}
	else if (!newSelected.includes("ALL") && newSelected.length === source.length - 1) {
		newSelected.push("ALL")
	}
	else if (newSelected.includes("ALL") && newSelected.length < source.length) {
		newSelected = newSelected.filter(elem => elem !== "ALL")
	}

	return newSelected
}

export const checkSubcontractorMultiInclude = (source, selected, value) => {
	let newSelected = value

	if (!selected.includes("ALL") && value.includes("ALL")) {
		newSelected = [...source, "ALL"]
	}
	else if (selected.includes("ALL") && !value.includes("ALL")) {
		newSelected = []
	}
	else if (!newSelected.includes("ALL") && newSelected.length === source.length) {
		newSelected.push("ALL")
	}
	else if (newSelected.includes("ALL") && newSelected.length === source.length) {
		newSelected = newSelected.filter(elem => elem !== "ALL")
	}

	return newSelected
}

export const concatAddress = (address, address1 = "", zipCode = "", city = "", country = "") => {
	let longAddress = address

	if (address1) longAddress += `, ${address1}`
	if (zipCode) longAddress += `, ${zipCode}`
	if (city) longAddress += `, ${city}`
	if (country) longAddress += `, ${country}`

	return longAddress
}

export const getDiffArrays = (a, b) => {
	const res = []

	for (const i in a) {
		const current = a[i]
		if (!b.includes(current)) {
			res.push(current)
		}
	}

	return res
}

export const isAmbientProduct = (element) => {
	if (element.productType === "SNACK" || element.productType === "YAOURT" || element.productType === "DRINK") {
		return true
	}
}

/**
 * generate random string with given length
 * @param {*} length 
 * @returns 
 */
export const generateRandomToken = (length = 12) => {
	return Math.random().toString(20).substr(2, length)
}

export const getCellAlignment = (align) => {
	switch (align) {
		case "center":
			return "center"
		case "right":
			return "flex-end"
		default:
			return "flex-start"
	}
}

export const isFalsyOtherThanZero = (field) => {
	return field === 0 || field
}

/**
 * Generate a string which vowels are replaced with accentuated equivalents
 * @param {String} value 
 * @returns {String}
 */
export const generateAccentuatedStringPattern = value => {
	if (!value || typeof value !== "string") return ""
	return value
		.replace(/[aáàäâ]/gi, "[aáàäâ]")
		.replace(/[eéëèê]/gi, "[eéëèê]")
		.replace(/[iíïìî]/gi, "[iíïìî]")
		.replace(/[oóöòô]/gi, "[oóöòô]")
		.replace(/[uüúùû]/gi, "[uüúùû]")
}

/**
 * change csv separator in column text to avoid column decalage
 * @param {*} str 
 * @returns 
 */
export const replaceCSVSeparatorInText = (str) => {
	let formattedValue = ""
	if (str) {
		formattedValue = str.replaceAll(":", ".")
		formattedValue = formattedValue.replaceAll(";", ".")
	}

	return formattedValue
}

/**
 * 
 * @param {*} date timestamp
 */
export const getTimezoneDate = (date, returnType = "timestamp", startOfDay = true) => {
	const timezoneOffset = moment(date).utcOffset()
	const dateWithOffset = startOfDay ? moment(date).utc().add(timezoneOffset, "minutes").startOf("day") : moment(date).utc().add(timezoneOffset, "minutes")

	if (returnType === "moment") {
		return dateWithOffset
	}
	return dateWithOffset.valueOf()
}

export const dateToTimestamp = (date) => {
	return dayjs.utc(date).valueOf()
}

export const timestampToDate = (timestamp, format = "YYYY-MM-DD") => {
	if (!timestamp) return ""
	return dayjs(timestamp).format(format)
}

export const getProdDayFilterWindow = (deliveryDays) => {
	const latest = new Date(Math.max(...deliveryDays.map((d) => new Date(d.date))))
	const isoDay = latest.getDay() || 7
	const monday = new Date(latest)
	monday.setDate(latest.getDate() - isoDay + 1)
	const wednesdayPrevWeek = new Date(monday)
	wednesdayPrevWeek.setDate(monday.getDate() - 5)
	return { start: wednesdayPrevWeek, end: latest }
}

export const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms))


export const isDateObject = (value) => {
	return isDate(value) || moment.isMoment(value) || dayjs.isDayjs(value)
}

export const camelToSnakeCase = (str) => {
	return str.replace(/([A-Z])/g, letter => `_${letter.toLowerCase()}`)
}

export const convertKeysToSnakeCase = (obj) => {
	const newObj = {}

	for (let key in obj) {
		if (obj.hasOwnProperty(key)) {
			const snakeCaseKey = camelToSnakeCase(key)
			newObj[snakeCaseKey] = obj[key]
		}
	}

	return newObj
}

export const composes = (...fns) => (inputValue) => fns.reduce((acc, fn) => fn(acc), inputValue)

export const getNameInEmail = (email) => {
	const [name] = email.split("@")
	return name
}

export function replacePropertyValuesFromMap(obj, valueMap, targetProp = "index") {
	if (Array.isArray(obj)) {
		return obj.map(item => replacePropertyValuesFromMap(item, valueMap, targetProp))
	} else if (obj !== null && typeof obj === "object") {
		const result = {}
		for (const key in obj) {
			if (key === targetProp && valueMap.has(obj[key])) {
				result[key] = valueMap.get(obj[key])
			} else {
				result[key] = replacePropertyValuesFromMap(obj[key], valueMap, targetProp)
			}
		}
		return result
	} else {
		return obj
	}
}

// compare two objects deeply, ignoring order of arrays
export function deepEqualIgnoreOrder(a, b, ignoredFields = ["_objCount"]) {
	if (a === b) return true

	if (typeof a !== typeof b || a === null || b === null) {
		return false
	}

	if (typeof a !== "object") {
		return a === b
	}

	// if both are arrays
	if (Array.isArray(a)) {
		if (!Array.isArray(b) || a.length !== b.length) return false

		// Compare array elements without considering order
		const usedIndices = new Set()
		for (let itemA of a) {
			let found = false
			for (let i = 0; i < b.length; i++) {
				if (usedIndices.has(i)) continue
				if (deepEqualIgnoreOrder(itemA, b[i], ignoredFields)) {
					usedIndices.add(i)
					found = true
					break
				}
			}
			if (!found) return false
		}
		return true
	}

	const keysA = Object.keys(a).filter(key => !ignoredFields.includes(key))
	const keysB = Object.keys(b).filter(key => !ignoredFields.includes(key))

	if (keysA.length !== keysB.length) return false

	for (let key of keysA) {
		if (!keysB.includes(key)) return false
		if (!deepEqualIgnoreOrder(a[key], b[key], ignoredFields)) return false
	}

	return true
}

/**
 * Find all objects where a given path matches a target value.
 *
 * Options:
 * - recursive: scan deeply into nested objects/arrays
 * - tree: return container structure around matched value
 * - path: include access path as 'path' field in result
 */
export function findObjectByPathValue(obj, path, targetValue, options = {}) {
	if (typeof obj !== "object" || obj === null) return []

	const pathParts = path.split(".")
	const lastKey = pathParts.at(-1)
	const containerPath = pathParts.slice(0, -1)

	const recursive = options.recursive === true
	const returnTree = options.tree === true
	const includePath = options.path === true

	// Track visited objects to prevent infinite loops
	const visited = new Set()

	// Convert the traversal stack to a path string like "a[0].b.c"
	function buildPathString(stack) {
		return stack
			.map(({ key, index }) => (typeof index === "number" ? `${key}[${index}]` : key))
			.join(".")
	}

	// topParent = the object that contains the first key of the path
	function resolveFromPath(obj, parts, topParent = obj) {
		if (parts.length === 0) return [{ value: obj, stack: [], topParent }]
		if (typeof obj !== "object" || obj === null) return []

		const [key, ...rest] = parts
		const next = obj[key]

		if (Array.isArray(next)) {
			return next.flatMap((item, i) =>
				resolveFromPath(item, rest, topParent).map(r => ({
					value: r.value,
					stack: [...r.stack, { key, index: i, value: item }],
					topParent
				}))
			)
		}

		if (typeof next === "object" && next !== null) {
			return resolveFromPath(next, rest, topParent).map(r => ({
				value: r.value,
				stack: [...r.stack, { key, value: next }],
				topParent
			}))
		}

		return []
	}

	function buildResultTree(stack, topParent) {
		const result = {}
		for (const { key, value } of stack) {
			if (!result[key]) result[key] = value
		}
		const last = stack.at(-1)
		if (last?.key && typeof last.value === "object") {
			result[last.key] = last.value
		}
		if (topParent) result.parent = topParent
		return result
	}

	function matchAtLevel(base, topParent = base) {
		// Cas simple (pas de chemin imbriqué)
		if (containerPath.length === 0) {
			if (base?.[lastKey] === targetValue) {
				let value = base // on retourne l'objet parent (contenant lastKey)
				if (returnTree) value = { [lastKey]: value, root: topParent }
				if (includePath && typeof value === "object") {
					value = { ...value, path: buildPathString([{ key: lastKey }]) }
				}
				return [value]
			}
			return []
		}

		// Cas avec chemin imbriqué
		return resolveFromPath(base, containerPath, topParent)
			.filter(r => r.value?.[lastKey] === targetValue)
			.map(r => {
				const stack = r.stack.concat({ key: lastKey })
				let value

				if (returnTree) {
					value = buildResultTree([...r.stack, { key: lastKey, value: r.value }], r.topParent)
				} else {
					value = r.value
					if (r.topParent) value = { ...value, root: r.topParent }
				}

				if (includePath && typeof value === "object") {
					value = { ...value, path: buildPathString(stack) }
				}
				return value
			})
	}

	function search(obj) {
		if (typeof obj !== "object" || obj === null) return []
		if (visited.has(obj)) return []
		visited.add(obj)

		const found = matchAtLevel(obj, obj)
		if (!recursive) return found

		const children = Array.isArray(obj) ? obj : Object.values(obj)
		return found.concat(children.flatMap(search))
	}

	return search(obj)
}
/**
 * e.g: 000123 -> 123
 * @description Remove leading zeros from a value and return it as a string or number.
 * @param {*} value 
 * @param {*} returnType 
 * @returns 
 */
export const removeLeadingZeros = (value, returnType = "string") => {
	const str = String(value)
	const result = str.replace(/^0+/, "")
	return returnType === "number" ? Number(result) : result
}

export const clearDataGridPersistedFilter = (path) => localStorage.removeItem(path)

export const formatEmailToName = email => {
	if (!email || typeof email !== "string") return ""
	if (!email.includes("@") || email.startsWith("@") || email.endsWith("@")) return email

	const namePart = email.split("@")[0]
	const parts = namePart.split(/[._-]/)
	const capitalizedParts = parts.map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())

	return capitalizedParts.join(" ")
}

/**
 * format date string to url format
 * @example: formatDateUrl("31-12-2024") => "31/12/2024" or formatDateUrl("31-12-2024", true) => "2024/12/31"
 * @param {string} date in format DD-MM-YYYY
 * @param {boolean} useIntelFormat if true, format to DD/MM/YYYY
 * @returns {string} formatted date string
 */
export const formatDateUrl = (date, useIntelFormat = false) => {
	let dateStr = date.split("-").join("/")

	if (useIntelFormat) {
		const [year, month, day] = date.split("-")
		dateStr = `${day}/${month}/${year}`
	}

	return dateStr
}

export const parseQueryParamsToUrl = (mainUrl = "/", queryParamsObj) => {
	let url = mainUrl
	if (queryParamsObj) {
		const queryParams = Object.entries(queryParamsObj)
			.map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
			.join("&")
		url += `?${queryParams}`
	}

	return url
}